import { render, staticRenderFns } from "./customerStatistic.vue?vue&type=template&id=29bbb68b&scoped=true"
import script from "./customerStatistic.vue?vue&type=script&lang=js"
export * from "./customerStatistic.vue?vue&type=script&lang=js"
import style0 from "./customerStatistic.vue?vue&type=style&index=0&id=29bbb68b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbb68b",
  null
  
)

export default component.exports